import { css } from '@emotion/css'
import { minScreen } from 'utils/mediaQueries'
import { Color } from 'utils/variables'

export const text = css`
  margin: 0;
  color: ${Color.LightBlack};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const tac = css`
  text-align: center;
`;

export const pcHidden = css`
  display: block;
  ${minScreen('md')} {
    display: none;
  }
`;